import React, { useState, useEffect, useRef } from 'react';
import CustomImage from './CustomImage';


function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const WhenClosed = ({ open, settings, bubble }) => {
  const [showBubble, setShowBubble] = useState(false);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const bubbleColor = settings.color;
  const closeicon = 'https://flaticons.net/icon.php?slug_category=mobile-application&slug_icon=close';
  const cleanedName = settings.name.replace(/\.[a-z]+$/, '');
  const UsefullName = capitalizeFirstLetter(cleanedName);

  // Use a ref to keep track of how many times the bubble has popped up
  const bubbleCount = useRef(0);

  useEffect(() => {
    if (bubbleCount.current >= 2 || !bubble) return; // Prevent further popups if count is 2 or more or if bubble is false

    // Add a delay before showing the bubble
    const bubbleTimer = setTimeout(() => {
      setShowBubble(bubble);
      if (bubble) {
        bubbleCount.current += 1;
        // Add a delay before showing the close button
        const closeButtonTimer = setTimeout(() => {
          setShowCloseButton(true);
        }, 250); // 500ms delay for the close button
        return () => clearTimeout(closeButtonTimer); // Cleanup the close button timer
      } else {
        setShowCloseButton(false);
      }
    }, 1000); // 2500ms delay for the bubble

    return () => clearTimeout(bubbleTimer); // Cleanup the bubble timer on unmount or when bubble changes
  }, [bubble]); // Add bubble as a dependency

  const handleCloseBubble = () => {
    setShowBubble(false);
    setShowCloseButton(false);
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        textAlign: 'center',
      }}
    >
      {/* Conditionally render the bubble with animation */}
      <div
        style={{
          position: 'absolute',
          bottom: '90px',
          right: '10px',
          backgroundColor: bubbleColor,
          color: 'white',
          padding: '10px 15px',
          borderRadius: '20px',
          fontSize: '16px',
          width: '270px',
          wordWrap: 'break-word',
          whiteSpace: 'normal',
          textAlign: 'left',
          opacity: showBubble ? 1 : 0,
          transform: showBubble ? 'translateY(0)' : 'translateY(20px)',
          transition: 'opacity 0.5s ease, transform 0.5s ease',
          fontFamily: 'Arial, sans-serif',
          boxShadow: `0px 6px 12px rgba(0, 0, 0, 0.3)`,
          zIndex: 1,
        }}
      >
        Hi, <br />I am {UsefullName}s assistant I can<br />Help answer your questions!
      </div>

      {/* Close button for the chat bubble */}
      <button
        onClick={handleCloseBubble}
        style={{
          position: 'absolute',
          bottom: '190px',
          right: '11px',
          backgroundColor: bubbleColor,
          border: 'none',
          outline: 'none',
          cursor: 'pointer',
          padding: 0,
          borderRadius: '50%',
          zIndex: 2,
          width: '24px',
          height: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: showCloseButton ? 1 : 0,
          transform: showCloseButton ? 'translateY(0)' : 'translateY(20px)',
          transition: 'opacity 0.5s ease, transform 0.5s ease',
          boxShadow: `0px 4px 8px rgba(0, 0, 0, 0.3)`, // Shadow around the close button
        }}
      >
        <img src={closeicon} alt="Close" style={{ width: '12px', height: '12px' }} />
      </button>

      {/* Button with the image */}
      <button
        onClick={open}
        style={{
          position: 'fixed', // Original fixed position
          bottom: '20px',
          right: '20px',
          outline: 'none',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 0, // Remove default button padding
          // No shadow applied to the button
        }}
      >
        <CustomImage color={settings.color} />
      </button>
    </div>
  );
};

export default WhenClosed;